module.exports = __webpack_public_path__ + "static/media/why-subscribe-bg.b93ee223.png";